var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSettingsGeneral(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.842 2.666c.728.183 1.414.47 2.04.846l-.048.935c-.05 1 .722 1.77 1.719 1.719l.935-.049c.376.627.663 1.313.846 2.04l-.696.628c-.744.67-.741 1.761 0 2.43l.696.627a7.515 7.515 0 0 1-.846 2.04l-.935-.048c-1-.05-1.77.722-1.719 1.719l.048.935a7.515 7.515 0 0 1-2.04.846l-.627-.696c-.67-.744-1.761-.741-2.43 0l-.627.696a7.515 7.515 0 0 1-2.04-.846l.048-.935c.05-1-.722-1.77-1.719-1.719l-.935.048a7.515 7.515 0 0 1-.846-2.04l.696-.627c.744-.67.741-1.761 0-2.43l-.696-.627c.183-.728.47-1.414.846-2.04l.935.048c1 .05 1.77-.722 1.719-1.719l-.049-.935a7.515 7.515 0 0 1 2.04-.846l.628.696c.67.744 1.761.741 2.43 0zM10 7.732a2.268 2.268 0 1 0 0 4.536 2.268 2.268 0 0 0 0-4.536z",
    fill: "#4A4A4A",
    stroke: "#4A4A4A",
    strokeWidth: 1.369
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettingsGeneral);
export default __webpack_public_path__ + "static/media/icon-settings-general.24aa6347.svg";
export { ForwardRef as ReactComponent };